import axios from "axios";
import { BASE_URL, IMAGE_URL } from "../config"; // Assuming IMAGE_UPLOAD_URL is the base for image upload

const client = async (endpoint, { method, body, ...customConfig } = {}) => {
  const headers = {};

  const token = sessionStorage.getItem("token");
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const options = {
    method: method || "GET",
    url: `${BASE_URL}${endpoint}`,
    headers: {
      ...headers,
      ...customConfig.headers,
    },
    ...(body && (method === "POST" || method === "PUT") ? { data: body } : {}),
    ...customConfig,
  };

  try {
    const response = await axios(options);

    if (response?.status === 401) {
      sessionStorage.removeItem("token");
      window.location.href = "/"; // Redirect to login page
    } else {
      return response?.data;
    }
  } catch (err) {
    const errorMessage =
      err.response?.data?.message || err.message || "An error occurred";
    return Promise.reject({
      message: errorMessage,
      status: err.response?.status,
      data: err.response?.data,
    });
  }
};

// Existing methods
client.get = function (endpoint, customConfig = {}) {
  return client(endpoint, { ...customConfig, method: "GET" });
};

client.post = function (endpoint, body, customConfig = {}) {
  return client(endpoint, { ...customConfig, method: "POST", body });
};

client.put = function (endpoint, body, customConfig = {}) {
  return client(endpoint, { ...customConfig, method: "PUT", body });
};

client.delete = function (endpoint, customConfig = {}) {
  return client(endpoint, { ...customConfig, method: "DELETE" });
};

// New method for file uploads (using IMAGE_UPLOAD_URL)
client.file = async function (endpoint, formData, customConfig = {}) {
  const token = sessionStorage.getItem("token");
  const headers = {
    Authorization: token ? `Bearer ${token}` : "",
    ...customConfig.headers, // Use any custom headers if passed
  };

  const options = {
    method: "POST",
    url: `${IMAGE_URL}${endpoint}`, // Using image-specific base URL
    headers: {
      ...headers,
    },
    data: formData, // Directly pass the formData from the frontend
    ...customConfig,
  };

  try {
    const response = await axios(options);

    if (response?.status === 401) {
      sessionStorage.removeItem("token");
      window.location.href = "/"; // Redirect to login page if unauthorized
    } else {
      return response?.data;
    }
  } catch (err) {
    const errorMessage =
      err.response?.data?.message || err.message || "An error occurred";
    return Promise.reject({
      message: errorMessage,
      status: err.response?.status,
      data: err.response?.data,
    });
  }
};

export default client;
